import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_IS_OPEN_DIALOG: 'SET_IS_OPEN_DIALOG',
    SELECTED_TARGET: 'SELECTED_TARGET',
    POST_OPERATION_SETTING: 'POST_OPERATION_SETTING',
    GET_HUB_LIST: 'GET_HUB_LIST',
    GET_STORE_LIST: 'GET_STORE_LIST',
    SET_SELECTED_HUB: 'SET_SELECTED_HUB',
    UPDATE_SEARCH_QUERY: 'UPDATE_SEARCH_QUERY',
    UPDATE_CHECK_BOX: 'UPDATE_CHECK_BOX',
    CHECK_ITEM: 'CHECK_ITEM',
    UNCHECK_ITEM: 'UNCHECK_ITEM',
    UNCHECK_ALL_ITEM: 'UNCHECK_ALL_ITEM',
    CLEAR_ALL_INPUT: 'CLEAR_ALL_INPUT',
};
export const operationSettingMutationType = vuexEventPathGenerator(mutationType, 'operationSetting');
const mutations = {
    [mutationType.SET_IS_OPEN_DIALOG](state, payload) {
        state.isOpen = payload;
    },
    [mutationType.SELECTED_TARGET](state, target) {
        state.selectedTarget = target;
    },
    [mutationType.CLEAR_ALL_INPUT](state) {
        state.selectedTarget = 'hub';
        state.hub.list = [];
        state.hub.checkedList = [];
        state.hub.searchQuery = '';
        state.hub.selectedHub = null;
        state.store.list = [];
        state.store.checkedList = [];
        state.store.searchQuery = '';
    },
    [mutationType.POST_OPERATION_SETTING](state, { newData, target, }) {
        state[target].checkedList.forEach((checkedItem) => {
            Object.entries(newData).forEach(([key, value,]) => {
                // Vue.set(checkedItem, key, value);
                checkedItem[key] = value;
            });
        });
    },
    [mutationType.GET_HUB_LIST](state, payload) {
        state.hub.list = payload;
    },
    [mutationType.GET_STORE_LIST](state, payload) {
        state.store.list = payload;
    },
    [mutationType.SET_SELECTED_HUB](state, hub) {
        state.hub.selectedHub = hub;
    },
    [mutationType.UPDATE_SEARCH_QUERY](state, { target, word }) {
        state[target].searchQuery = word;
    },
    /** 체크박스 관련 */
    [mutationType.UPDATE_CHECK_BOX](state, { target, selected }) {
        state[target].checkedList = selected;
    },
    [mutationType.CHECK_ITEM](state, { target, item }) {
        // Vue.set(state[target].checkedList, state[target].checkedList.length, item);
        state[target].checkedList[state[target].checkedList.length] = item;
    },
    [mutationType.UNCHECK_ITEM](state, { target, itemCode }) {
        state[target].checkedList = state[target].checkedList.filter(({ code }) => code !== itemCode);
    },
    [mutationType.UNCHECK_ALL_ITEM](state, { target }) {
        state[target].checkedList = [];
    },
};
export default mutations;
